import * as React from "react";
import { Box, Drawer, IconButton, useMediaQuery } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

export const SIDEBAR_WIDTH = 260;

export default function ChatShell({ sidebar, header, empty, body, footer, isNewChat, collapsed, onToggleCollapse }) {
    const isMobile = useMediaQuery("(max-width:767.95px)");
    const sidebarOpen = !collapsed;

    const sidebarPanel = <Box sx={{ width: SIDEBAR_WIDTH, height: "100%", bgcolor: "background.default" }}>{sidebar}</Box>;

    return (
        <Box sx={{ display: "flex", height: "100%", minHeight: 0 }}>
            {isMobile ? (
                <Drawer anchor="left" open={sidebarOpen} onClose={onToggleCollapse}>
                    {sidebarPanel}
                </Drawer>
            ) : (
                sidebarOpen && (
                    <Box sx={{ borderRight: "1px solid", borderColor: "divider", flexShrink: 0 }}>{sidebarPanel}</Box>
                )
            )}

            <Box sx={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
                <Box sx={{ display: "flex", alignItems: "center", minHeight: 48 }}>
                    {(isMobile || !sidebarOpen) && (
                        <IconButton aria-label="Open sidebar" onClick={onToggleCollapse} sx={{ ml: 1 }}>
                            <MenuIcon />
                        </IconButton>
                    )}
                    <Box sx={{ flex: 1, minWidth: 0 }}>{header}</Box>
                </Box>

                {isNewChat ? (
                    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", px: 2, pb: 4 }}>
                        {empty}
                        {footer}
                    </Box>
                ) : (
                    <>
                        <Box sx={{ flex: 1, overflowY: "auto", px: { xs: 2, md: 3 }, py: 2, minHeight: 0 }}>
                            <Box sx={{ maxWidth: 760, mx: "auto" }}>{body}</Box>
                        </Box>
                        <Box sx={{ px: 2, pb: 2, pt: 1 }}>{footer}</Box>
                    </>
                )}
            </Box>
        </Box>
    );
}
